import { connect } from 'react-redux';
import Listings from 'components/listings/Listings';
import { selectFeatureList } from '../modules/geojson/selectors';
import {
  selectFeature,
  selectHoveredFeatureId,
  selectSelectedFeatureId,
  hoverFeature,
  unhoverFeature,
} from '../modules/map';

export default connect(
  state => ({
    list: selectFeatureList(state),
    hoveredFeatureId: selectHoveredFeatureId(state),
    selectedFeatureId: selectSelectedFeatureId(state),
  }),
  { selectFeature, hoverFeature, unhoverFeature },
)(Listings);
